module.exports = __webpack_public_path__ + "img/tm-1.bd4213f3.png";